import { Component, OnDestroy, OnInit } from '@angular/core';
import { BookingService } from '../../services/booking.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AdyenService } from 'src/app/services/adyen.service';
import { Store } from 'src/app/store';
import { ToolsService } from 'src/app/services/tools.service';
import { TrybeService } from 'src/app/services/trybe.service';
import { OpenTableService } from 'src/app/services/open-table.service';

@Component({
    selector: 'app-booking-view',
    templateUrl: './booking-view.component.html',
    styleUrls: ['./booking-view.component.css']
})
export class BookingViewComponent implements OnInit, OnDestroy {
    overlays$ = this.store.select<any>('overlays');
    cancelling = false;
    cancellingOpenTable = false;

    showRefundModal = false;
    showPaymentModal = false;
    paymentLinkData = undefined;
    paymentData: any = {};
    refundData: any = {};
    payAmountLocked = false;

    user$ = this.store.select<any>('user');

    charge = {
        value: 0,
        description: ''
    }
    chargeError = false;

    id = '';
    booking: any;
    spaBooking: any;
    cards = [];
    cardIdx = 0;

    cardSelected = undefined;
    requestingPayment = false;
    processingPayment = false;
    amountToPay = 0;
    paymentResult = undefined;

    confirmationData = {
        open: false,
        buttonText: 'Confirm',
        title: '',
        detail: '',
        data: undefined,
    };
    confirmationOpenTableData = {
        open: false,
        buttonText: 'Confirm',
        title: '',
        detail: '',
        data: undefined,
    };

    intervalId: any;

    constructor(
        private bookingService: BookingService,
        private adyenService: AdyenService,
        private router: Router,
        private route: ActivatedRoute,
        private store: Store,
        private toolsService: ToolsService,
        private trybeService: TrybeService,
        private openTableService: OpenTableService,
    ) { }

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];
        this.get();
        this.start();
    }

    ngOnDestroy() {
        this.end();
    }
    start() {
        this.intervalId = setInterval(() => {
            this.refreshBooking()
        }, 10000);

    }
    end() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }

    refreshBooking() {
        this.bookingService.get(this.id).subscribe(data => {
            this.booking.paymentHistory = data.paymentHistory;
            this.booking.payment = data.payment;
            this.amountToPay = data.payment.gross - data.payment.deposit;

            this.getUserCards();
            if (!this.payAmountLocked) {
                this.paymentData.valueToDisplay = this.amountToPay;
            }
        });
    }

    get() {
        this.bookingService.get(this.id).subscribe(data => {
            this.booking = data;
            this.booking.confirmed = false;
            this.amountToPay = this.booking.payment.unpaid;

            this.getUserCards();
            console.log(this.booking.trybeOrderId)
            if (this.booking.trybeOrderId) {
                this.getSpaOrder(this.booking.trybeOrderId, this.booking.hotel.id);
            }
            console.log(this.booking)
            this.paymentData.valueToDisplay = this.amountToPay;
            this.paymentData.shopper = {
                id: this.booking.customer.id,
                name: `${this.booking.customer.firstname} ${this.booking.customer.surname}`,
                email: this.booking.customer.email,
                firstname: this.booking.customer.firstname,
            };

            this.paymentData.user = this.booking.customer;
            this.paymentData.hotel = { id: this.booking.hotel.id, name: this.booking.hotel.name },
                this.paymentData.room = { id: this.booking.room.id, name: this.booking.room.name },
                this.paymentData.reference = `${this.booking.hotel.name} room booking`,
                this.paymentData.isBooking = true;

        });
    }

    getBooking(Id) {
        this.id = Id;
        this.get();
    }

    getSpaOrder(trybeOrderId, hotelId) {
        this.trybeService.getSpaOrder(trybeOrderId, hotelId).subscribe(data => {
            console.log(data.data.data);
            this.spaBooking = data.data.data;
        })
    }

    getUserCards() {
        const thisPsp = 'umknown';

        const d = {
            userId: this.booking.customer.id,
            hotelId: this.booking.hotel.id,
            roomId: this.booking.room.id,
            psp: thisPsp,
            username: this.booking.customer.email,
            merchantAccountCode: this.booking.paymentHistory[0].merchantAccountCode
        }
        this.adyenService.getUserCards(d).subscribe(data => {
            this.cards = data;
        })
    }

    cancelConfirm() {
        this.confirmationData.title = 'Confirm Cancellation';
        this.confirmationData.data = {};
        this.confirmationData.detail = 'Please confirm you would like to cancel this booking';
        this.confirmationData.open = true;
    }

    confirmAction(e) {
        if (e.action) {
            this.cancelling = true;
            this.bookingService.cancelBooking(this.booking.id).subscribe(data => {
                console.log(data)
                this.booking.resStatus = 'Cancelled';
                this.cancelling = false;
                console.log(this.spaBooking)
                if (this.spaBooking) {
                    this.trybeService.cancelSpaOrder(this.spaBooking.id, this.booking.hotel.id).subscribe(data => {
                        console.log(data);
                    })
                }

                if (this.booking.openTable) {
                    this.openTableService.cancel(this.booking.openTable.confirmationNumber).subscribe(data => {
                        console.log(data)
                        this.booking.openTable.cancelled = 1;
                        this.cancellingOpenTable = false;
                    });

                }
            });
        }
        this.confirmationData.open = false;
    }

    cancelOpenTableConfirm() {
        this.confirmationOpenTableData.title = 'Confirm Table Cancellation';
        this.confirmationOpenTableData.data = {};
        this.confirmationOpenTableData.detail = 'Please confirm you would like to cancel this table booking';
        this.confirmationOpenTableData.open = true;
    }

    confirmOpenTableAction(e) {
        if (e.action) {
            this.cancellingOpenTable = true;
            this.openTableService.cancel(this.booking.openTable.confirmationNumber).subscribe(data => {
                console.log(data)
                this.booking.openTable.cancelled = 1;
                this.cancellingOpenTable = false;
            });
        }
        this.confirmationOpenTableData.open = false;
    }

    createBookingLink(metadata) {

        this.adyenService.createBookingLink(metadata).subscribe(data => {
            console.log(data)
        })
    }


    setPaymentMethod(method) {
        this.end();
        this.paymentData.sendBookingLink = true;
        this.paymentData.adhoc = false;
        // this.paymentData.valueToDisplay = '1.00';

        this.paymentData.value = Math.round((+this.paymentData.valueToDisplay * 100) * 100) / 100;

        console.log(this.paymentLinkData)

        this.paymentData.lineItems = [
            { quantity: 1, amountIncludingTax: this.paymentData.value, description: this.booking.hotel.name + ' ' + this.booking.room.name }
        ];

        this.paymentData.method = method;
        this.paymentData.value = Math.round((+this.paymentData.valueToDisplay * 100) * 100) / 100;
        this.paymentData.metadata = {
            bookingId: this.booking.id,
            bookingLink: this.toolsService.newUUID(),
            method: method
        }
        this.paymentData.username = this.booking.customer.email,
            this.paymentData.merchantAccountCode = this.booking.paymentHistory[0].merchantAccountCode

        console.log(this.paymentData)
        this.showPaymentModal = true;

    }

    createCharge() {
        this.chargeError = false;
        console.log(this.charge)
        if (!this.charge.value || !this.charge.description) {
            this.chargeError = true;
            return;
        }

        this.end();
        this.paymentData.sendBookingLink = true;
        this.paymentData.adhoc = true;

        this.paymentData.shopper = {
            name: { firstName: this.booking.customer.firstname, lastName: this.booking.customer.surname },
            email: this.booking.customer.email,
            emailAlt: '',
            firstname: this.booking.customer.firstname
        }
        this.paymentData.reference = this.charge.description;

        // this.paymentData.valueToDisplay = '1.00';
        this.paymentData.valueToDisplay = +this.charge.value;

        this.paymentData.value = Math.round((+this.charge.value * 100) * 100) / 100;

        console.log(this.paymentLinkData)

        this.paymentData.lineItems = [
            { quantity: 1, amountIncludingTax: this.paymentData.value, description: this.charge.description }
        ];

        this.paymentData.method = 'stored';

        this.paymentData.metadata = {
            bookingId: this.booking.id,
            bookingLink: this.toolsService.newUUID(),
            method: 'stored',
            value: this.paymentData.value,
            reference: this.paymentData.reference,
            adhoc: true,
        }

        this.paymentData.username = this.booking.customer.email,
            this.paymentData.merchantAccountCode = this.booking.paymentHistory[0].merchantAccountCode

        console.log(this.paymentData)
        this.showPaymentModal = true;

    }


    lockPayAmount() {
        this.payAmountLocked = true;
    }
    paymentComplete(e) {
        this.payAmountLocked = false;
        this.refreshBooking();
        this.start();
        console.log(e)
        this.showPaymentModal = false;
        if (e.action) {
            // this.createBookingLink(e.paymentResult.metadata);
        }

        this.charge.value = 0;
        this.charge.description = '';

    }

    triggerRefund(payment) {
        console.log(payment)
        this.end();
        this.refundData.refundValue = payment.paid;
        this.refundData.payment = payment;
        this.refundData.bookingId = this.booking.id;
        this.showRefundModal = true;
    }

    refundComplete(e) {
        this.refreshBooking();
        this.start();
        console.log(e)
        this.showRefundModal = false;
        if (e.action) {
            // this.createBookingLink(e.paymentResult.metadata);
        }
    }

    triggerPayLinkResend(payment) {
        console.log(payment)
        const basket = this.store.selectForLocal('basket');
        const value = Math.round((+this.booking.payment.unpaid * 100) * 100) / 100;
        const valueToDisplay = +this.booking.payment.unpaid;

        const lineItems = [
            { quantity: 1, amountIncludingTax: value, description: this.booking.hotel.name + ' ' + this.booking.room.name }
        ];
        const shopper = {
            name: { firstName: this.booking.customer.firstname, lastName: this.booking.customer.surname },
            email: this.booking.customer.email,
            emailAlt: '',
            firstname: this.booking.customer.firstname
        }


        // console.log(this.paymentLinkData)

        this.paymentData = {
            resending: payment.payUrlId,
            sendBookingLink: false,
            method: 'link',
            value,
            valueToDisplay,
            shopper,
            lineItems,
            user: this.booking.customer.id,
            hotel: { id: this.booking.hotel.id, name: this.booking.hotel.name },
            room: { id: this.booking.room.id, name: this.booking.room.name },
            reference: `${this.booking.hotel.name} room booking`,
            isBooking: true,
            result: undefined,
            metadata: {
                bookingId: this.booking.id,
                bookingLink: this.toolsService.newUUID(),
                method: 'link',
                room: this.booking.hotel.name + ' ' + this.booking.room.name,
                customer: `${this.booking.customer.firstname} ${this.booking.customer.surname}`
            }
        }

        console.log(this.paymentData)

        this.showPaymentModal = true;

    }


}
